import PlanCheckout from "../features/planCheckout/PlanCheckout";


function Join() {
  return (
    <>
      {" "}
      <PlanCheckout />

    </>
  );
}
export default Join;
